<div class="moreInfoWeb" style="background: white !important;" 
                        fxHide.xs fxHide.sm fxHide.lt-md >

    <div fxLayout="row wrap" 
     fxFlex="100%" fxFlex.md="100%" fxFlex.lt-lg="100%" fxFlex.lg="100%" fxFlex.gt-xs="100%" fxFlex.gt-lg="100%">

        <div fxLayout="row" >
            <app-premiere-background-image *ngIf="premiereDetails" [premiereDetails]="premiereDetails" ></app-premiere-background-image>
        </div>

        <div fxLayout="row">
            <app-premiere-description *ngIf="premiereDetails" fxHide.sm [premiereDetails]="premiereDetails"></app-premiere-description>
        </div>
            
        <div fxLayout="row" class="trailer">
            <app-premiere-trailer *ngIf="trailerUrl" [trailerUrl]="trailerUrl" ></app-premiere-trailer>
        </div>



        <div class="featureGuest div3" fxLayout="row">
            <app-premiere-feature-guest *ngIf="premiereDetails"  [premiereDetails]="premiereDetails" [image]="image" [id]="eventid"></app-premiere-feature-guest>
        </div>

        <div class="eventAgenda div3" fxLayout="row">
            <app-premiere-event-agenda *ngIf="premiereDetails" [premiereDetails]="premiereDetails" [id]="eventid"></app-premiere-event-agenda>
        </div>

    </div>
    

</div>




<div class="mobile-view"  style="background: white !important; background-color: white !important; overflow-x: hidden !important;" 
                            *ngIf="mobilePremiereDetails "
                                
                                fxHide.lg 
                                fxHide.md 
                                fxHide.lt 
                                fxFlex.lt-md
                                fxHide.gt-lg >
                             
<div  fxLayout="row wrap" 
     fxFlex="100%" fxFlex.md="100%" >

        <div fxLayout="row" style="position: relative;">
            <app-mobile-premiere-background *ngIf="mobilePremiereDetails" [mobilePremiereDetails]="mobilePremiereDetails" ></app-mobile-premiere-background>
        </div>

        <div fxLayout="row" >
            <app-mobile-premiere-description *ngIf="mobilePremiereDetails" [mobilePremiereDetails]="mobilePremiereDetails" ></app-mobile-premiere-description>
        </div>

        <div fxLayout="row" class="mobileTrailer">
            <app-mobile-premiere-trailer *ngIf="trailerUrl"  [trailerUrl]="trailerUrl" ></app-mobile-premiere-trailer>
        </div>

        <div class="mobileFeatureGuest mobileDiv3" fxLayout="row" >
            <app-mobile-premiere-featured-guest *ngIf="mobilePremiereDetails"  [mobilePremiereDetails]="mobilePremiereDetails" [image]="image" [id]="eventid"></app-mobile-premiere-featured-guest>
        </div>

        <div class="mobileEventAgenda mobileDiv3" fxLayout="row">
            <app-mobile-premiere-event-agenda *ngIf="mobilePremiereDetails" [mobilePremiereDetails]="mobilePremiereDetails" [id]="eventid"></app-mobile-premiere-event-agenda>
        </div>

</div>
